var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn == true)?_c('div',[_c('v-navigation-drawer',{attrs:{"fixed":"","app":""}},[_c('AdminSidebar')],1),_c('v-container',{attrs:{"fill-height":""}},[_c('router-view',{on:{"snackbarevent":_vm.updateSnackbar}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }